// import withReducer from '../../store/withReducer'
// import reducer from './module'
import Settings from './container';

// export default withReducer('settings', reducer)(Settings)

export default Settings;
